module.exports = __webpack_public_path__ + "assets/img/BnBerry-Landing-Page-+-Website-w720.039be19b.jpg";